import { BLOOM_QUESTION_COUNT, bloomQuestions } from "./questions";
import type { BloomAnswers } from "../types/bloom-content";

/** Filled answers (midden van de schaal) om het eindscherm te previewen. */
export function createDebugAnswers(): BloomAnswers {
  const answers: BloomAnswers = {};
  for (const q of bloomQuestions) {
    answers[q.id] = 2;
  }
  return answers;
}

/** ponytail: tijdelijk uit — zet op true om debug-paneel, Ctrl+D en variant-picker weer aan te zetten */
const BLOOM_DEBUG_ENABLED = false;

function debugFromUrl(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).has("debug");
}

export function isBloomDev(): boolean {
  return import.meta.env.DEV && (BLOOM_DEBUG_ENABLED || debugFromUrl());
}

/** ponytail: dev-only — open met ?scenario om direct bij scenario-vragen te landen */
export function isScenarioPreview(): boolean {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).has("scenario");
}

/** Dev-only — open met ?intro-capture om intro-voorbeeldkaarten te screenshotten */
export function isIntroCapture(): boolean {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).has("intro-capture");
}

export const BLOOM_DEBUG_QUESTION_INDEX = BLOOM_QUESTION_COUNT - 1;
